export default __webpack_public_path__ + "static/media/How_to_ace_your_foreman_interview_IMAGE.f44cff2b.png";